import React, { useState } from 'react';
import { toast } from 'sonner';
import { api } from '../../lib/api';
import { BoardCard } from './BoardCard';

// Rotation boards in display order — drag a card onto another to reorder (HTML5 DnD).
export const RotationList = ({ boards, onChanged }) => {
  const [dragId, setDragId] = useState(null);
  const [order, setOrder] = useState(null);
  const ids = order || boards.map(b => b.id);
  const sorted = ids.map(id => boards.find(b => b.id === id)).filter(Boolean);

  const drop = async (targetId) => {
    if (!dragId || dragId === targetId) return;
    const next = ids.filter(i => i !== dragId);
    next.splice(next.indexOf(targetId), 0, dragId);
    setOrder(next); setDragId(null);
    try { await api.vbManagerReorder(next); toast.success('Reihenfolge gespeichert'); onChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Reihenfolge konnte nicht gespeichert werden'); setOrder(null); }
  };

  return (
    <div className="space-y-3" data-testid="vb-rotation-list">
      {sorted.map((b, i) => (
        <div key={b.id} draggable onDragStart={() => setDragId(b.id)} onDragOver={e => e.preventDefault()} onDrop={() => drop(b.id)}
          className={`relative ${dragId === b.id ? 'opacity-50' : ''}`} data-testid={`vb-rotation-item-${b.id}`}>
          <span className="absolute -left-6 top-4 text-[10px] font-mono text-muted-foreground w-5 text-right">{i + 1}.</span>
          <BoardCard board={b} onChanged={onChanged} dragHandle />
        </div>
      ))}
    </div>
  );
};
